import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsBikeNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 4v2h1.705l1.428 2.498-.836 1.672A5 5 0 109.9 16H11a1 1 0 00.868-.504l3.607-6.313.639 1.733a5 5 0 101.835-.806L16.434 6H19.5a.5.5 0 010 1H19v2h.5a2.5 2.5 0 000-5H15a1 1 0 00-.938 1.346L14.672 7H8.58L8.01 6H9V4zm4.325 6.585L10.277 14H6.618zM11.5 12.11L9.723 9h3.554zM5 12c.125 0 .25.008.37.023l-1.264 2.53A1 1 0 005 16h2.83A3.001 3.001 0 115 12zm11.848.91l1.06 2.874 1.876-.691-1.132-3.073a3 3 0 11-1.804.89z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsBikeNormalSmall;
